/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type BatchEvidencesJobSubmitInput = {
  dryRun?: boolean | null | undefined;
  dryRunOptions?: DryRunOptions | null | undefined;
  jobId: string;
  logLevel?: string | null | undefined;
  tenantId: string;
};

export type DryRunOptions = {
  limit?: number | null | undefined;
  offset?: number | null | undefined;
};

export type SubmitBatchEvidencesJobMutationVariables = Exact<{
  input: Types.BatchEvidencesJobSubmitInput;
}>;


export type SubmitBatchEvidencesJobMutation = { cnutSubmitBatchEvidencesJob:
    | { __typename: 'BatchEvidencesJobSubmitOutput', jobId: string, jobRunId: string }
    | { __typename: 'ClientError', code: string, message: string }
   };


export const SubmitBatchEvidencesJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitBatchEvidencesJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchEvidencesJobSubmitInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutSubmitBatchEvidencesJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BatchEvidencesJobSubmitOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"jobRunId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitBatchEvidencesJobMutation, SubmitBatchEvidencesJobMutationVariables>;